export default "__VITE_ASSET__Dywe9_mH__"